import { nanoid } from "@reduxjs/toolkit";
import React, { ChangeEventHandler, useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import Option from "../components/Option";
import tableIcon from "../components/custom/assets/images/dashboard/table_icon.svg";
import { FormInput, MultiSelect } from "../components/custom/components";
import FormInput2 from "../components/custom/components/FormInput2";
import {
  Tbody,
  Thead,
} from "../components/custom/components/TradeCategoryPerformanceTable";
import TransactionTable from "../components/custom/components/TransactionTable";
import UserLayout from "../components/custom/layouts/UserLayout";
import { ToastTypes, useToast } from "../components/toast/ToastProvider";
import { PAGE_SIZE } from "../config";
import api, { APIResponse, getAxiosRequestConfig } from "../config/api";
import { CSVdownload, handleDownloadPDF } from "../config/functions";
import { AuthUserType } from "../redux/actions/authUserActions";
import { BrandType } from "../redux/actions/brandActions";
import { BrandCompanyType } from "../redux/actions/brandCompanyActions";
import { PortfolioType } from "../redux/actions/portfolioActions";
import {
  OptionsTypes,
  addToSelectedOption,
} from "../redux/actions/selectedOptionsActions";
import { SiteType } from "../redux/actions/siteActions";
import { TradeCategoryType } from "../redux/actions/tradeCategoryActions";
import { TradeSubCategoryType } from "../redux/actions/tradeSubCategoryActions";
import { StoreState } from "../redux/store";
import {
  CatSubCatCompanyWithBrandRelationDataType,
} from "./TransactionBillWiseReport";
import Loader from "../components/custom/components/Loader";
import { areaType } from "../redux/actions/areaActions";
import { outletType } from "../redux/actions/outletActions";

export interface DropDownOption {
  value: number;
  label: string;
  imgUrl: string;
}

export interface MonthWiseRecord {
  tradecategory: string;
  tradesubcategory: string;
  brandname: string;
  level: string;
  landmark: string;
  datatransmode: string;
  jan: string;
  feb: string;
  mar: string;
  apr: string;
  may: string;
  jun: string;
  jul: string;
  aug: string;
  sep: string;
  oct: string;
  nov: string;
  dec: string;
  rsvalue?: string;
  rspercent?: string;
}

export interface MonthWiseReportType {
  portfolio: number;
  count?: number;
  record: MonthWiseRecord[];
}

const TransactionMonthWiseReportLocwise: React.FC = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const authUser = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  );
  const authUserToken = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  )?.["auth-token"]!;
  const config = getAxiosRequestConfig(authUserToken);
  const authUserSiteId = authUser?.siteId;

  const portfolioOption = useSelector<StoreState, PortfolioType[]>(
    (state) => state?.portfolio
  );
  const siteOption = useSelector<StoreState, SiteType[]>((state) => state?.site);
  const brandOption = useSelector<StoreState, BrandType[]>(
    (state) => state?.brand
  );
  const brandCompanyOption = useSelector<StoreState, BrandCompanyType[]>(
    (state) => state?.brandCompany
  );

  const selectedOption = useSelector<StoreState, OptionsTypes>(
    (state) => state?.selectedOption
  );

  const categoryOption = useSelector<StoreState, TradeCategoryType[]>(
    (state) => state?.tradeCategory
  );
  const subCategoryOption = useSelector<StoreState, TradeSubCategoryType[]>(
    (state) => state?.tradeSubCategory
  );
  const outletList = useSelector<StoreState, outletType[]>(
    (state) => state?.outlet
  );  
  const localityOption = useSelector<StoreState, areaType[]>(
    (state) => state?.locality
  );
  const [
    catSubCatCompanyWithBrandRelationData,
    setCatSubCatCompanyWithBrandRelationData,
  ] = useState<CatSubCatCompanyWithBrandRelationDataType[]>([]);

  const filteredBrandCompany = brandCompanyOption?.filter(
    (a) => a?.retailid !== null
  );

  const filteredBrand = brandOption?.filter((a) => {
    return brandCompanyOption?.some(
      (b) => b?.id?.toString() === a?.companyid?.toString() && b?.retailid !== null
    );
  });

  const port =
    authUser?.portfolioId !== undefined && authUser?.portfolioId !== null
      ? authUser?.portfolioId?.split(",")
      : [];

  let portfolioData = port
    ?.map((pe) => {
      return portfolioOption?.filter(
        (f) => f?.id?.toString() === pe?.toString()
      );
    })
    ?.flat(1);

  const st =
    authUser?.siteId !== undefined && authUser?.siteId !== null
      ? authUser?.siteId?.split(",")
      : [];

  let siteData = st
    ?.map((pe) => {
      return siteOption?.filter((f) => f?.id?.toString() === pe?.toString());
    })
    ?.flat(1);

  const br =
    authUser?.brandId !== undefined && authUser?.brandId !== null
      ? authUser?.brandId?.split(",")
      : [];

  let brandData = br
    ?.map((b) => {
      return filteredBrand?.filter((f) => f?.id?.toString() === b?.toString());
    })
    ?.flat(1);


  const [year, setYear] = useState<Date>(new Date());

  const [portfolios, setPortfolios] = useState<string>("");
  const [sites, setSites] = useState<string>("");
  const [brands, setBrands] = useState<string>("");

  const [locations, setLocations] = useState<DropDownOption[]>([]);
  const [categories, setCategories] = useState<string>("");
  const [subCategories, setSubCategories] = useState<string>("");

  //loader
  const [fileLoader, setFileLoader] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [pag, setPag] = useState<boolean>(false);
  const [valueIn, setValueIn] = useState<string>("");

  const [monthWiseData, setMonthWiseData] = useState<MonthWiseReportType[]>([]);

  const limit = PAGE_SIZE;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(50);

  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [disableLocality, setDisableLocality] = useState<boolean>(false);
  const handleSelectedRowsChange = (selectedRows: string[]) => {
    setSelectedRows(selectedRows);
  };
  const subCategoryFilteredByCategory = useMemo<TradeSubCategoryType[]>(() => {
    if (categories !== "") {
      return subCategoryOption?.filter((sc) => {
        return sc?.catid?.toString() === categories?.toString();
      });
    } else return subCategoryOption;
  }, [categories, subCategoryOption]);

  
  const BrandFilteredByCompany = useMemo<BrandType[]>(() => {
    if (subCategories !== "") {
      let brands: BrandType[] = [];
      catSubCatCompanyWithBrandRelationData?.forEach((s) => {
        let obj = s?.record?.find((r) =>
          r?.tradesubcatids?.split(",")?.includes(subCategories)
        );
        obj?.brandids?.split(",")?.forEach((m) => {
          let bc = brandData?.find((f) => f?.id?.toString() === m);
          brands?.push(bc!);
        });
      });
      return brands;
    } else if (categories !== "") {
      let brands: BrandType[] = [];
      catSubCatCompanyWithBrandRelationData?.forEach((s) => {
        let obj = s?.record?.find((r) => r?.tradecatid?.toString() === categories);
        obj?.brandids?.split(",")?.forEach((m) => {
          let bc = brandData?.find((f) => f?.id?.toString() === m);
          brands?.push(bc!);
        });
      });
      return brands;
    } else return brandData;
  }, [
    brandData,
    catSubCatCompanyWithBrandRelationData,
    categories,
    subCategories,
  ]);

  const handlePortfolioChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (fileLoader === false) {
      setPortfolios(e?.target?.value);
      setSites("");
      setLocations([]);
      const data = {
        ...selectedOption,
        portfolio: e?.target?.value,
        site: "",
        location: "",
      };
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
    }
  };

  // const handleLocationChange: ChangeEventHandler<HTMLInputElement> = (e) => {
  //   if (fileLoader === false) {
  //     setLocation(e?.target?.value);
  //     const data = { ...selectedOption, location: e?.target?.value };
  //     dispatch(addToSelectedOption(data));
  //     setOffset(0);
  //     setPag(false);
  //   }
  // };

  const handleCategoryChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (fileLoader === false) {
      setCategories(e?.target?.value);
      setSubCategories("");
      const data = {
        ...selectedOption,
        category: e?.target?.value,
        subCategory: "",
        company: "",
        brand: "",
      };
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
    }
  };
  const handleSubCategoryChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (fileLoader === false) {
      setSubCategories(e?.target?.value);
      const data = {
        ...selectedOption,
        subCategory: e?.target?.value,
        company: "",
        brand: "",
      };
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
    }
  };
  const handleBrandChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (fileLoader === false) {
      setBrands(e?.target?.value);
      const data = { ...selectedOption, brand: e?.target?.value };
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
    }
  };

  const tHead: Thead[] = [
    {
      id: "Trade Category",
      children: "Trade Category",
      text: "Trade Category",
    },
    {
      id: "Trade Sub Category",
      children: "Trade Sub Category",
      text: "Trade Sub Category",
    },
    { id: "Brand Name", children: "Brand Name", text: "Brand Name" },
    { id: "Level", children: "Level", text: "Level" },
    { id: "Landmark", children: "Landmark", text: "Landmark" },
    {
      id: "Data Transfer Mode",
      children: "Data Transfer Mode",
      text: "Data Transfer Mode",
    }
  ];
  if(!selectedOption?.isOutletUser){
    tHead?.push(
    // { id: "Revenue Share(%)", children: "Revenue Share(%)", text: "Revenue Share(%)" },
    { id: "Revenue", children: "Revenue", text: "Revenue" },
    )
  }
  tHead?.push(
    { id: "Jan", children: "Jan", text: "Jan" },
    { id: "Feb", children: "Feb", text: "Feb" },
    { id: "Mar", children: "Mar", text: "Mar" },
    { id: "Apr", children: "Apr", text: "Apr" },
    { id: "May", children: "May", text: "May" },
    { id: "Jun", children: "Jun", text: "Jun" },
    { id: "Jul", children: "Jul", text: "Jul" },
    { id: "Aug", children: "Aug", text: "Aug" },
    { id: "Sep", children: "Sep", text: "Sep" },
    { id: "Oct", children: "Oct", text: "Oct" },
    { id: "Nov", children: "Nov", text: "Nov" },
    { id: "Dec", children: "Dec", text: "Dec" },
  );

  const fetchDataForDownload = async () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    } else if (brands === "") {
      toast("Select Brand", ToastTypes?.ERROR);
      error = true;
    } else if (
      year === null ||
      (year !== null && year?.getFullYear()?.toString() === "")
    ) {
      toast("Select year", ToastTypes?.ERROR);
      error = true;
    }

    var getData = {
      portfolio: portfolio,
      site: site,
      locality: locality,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: year?.getFullYear(),
    };

    if (error === false && getData !== undefined) {
      const response = await api.post<
        APIResponse<{ records: MonthWiseReportType[] }>
      >(`kpi/report/monthwise`, getData, config);

      if (response?.status === 200 && response?.data?.data) {
        return response?.data?.data?.records;
      }
    }

    return [];
  };

  const getDownloadData = (Data: MonthWiseReportType[]) => {
    var tableHead: Thead[] = tHead;
    var tableBody: Tbody[][] = [];

    const tbody = Data;

    tbody?.forEach((month, i) => {
      month?.record?.forEach((item) => {
        //     selectedYears?.forEach((sy) => {
        var tBody: Tbody[] = [];
        tBody?.push(
          {
            id: nanoid(),
            theadId: "Trade Category",
            children: item?.tradecategory,
            text: item?.tradecategory,
          },
          {
            id: nanoid(),
            theadId: "Trade Sub Category",
            children: item?.tradesubcategory,
            text: item?.tradesubcategory,
          },
          {
            id: nanoid(),
            theadId: "Brand Name",
            children: item?.brandname,
            text: item?.brandname,
          },
          {
            id: nanoid(),
            theadId: "Level",
            children: item?.level,
            text: item?.level?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Landmark",
            children: item?.landmark,
            text: item?.landmark,
          },
          {
            id: nanoid(),
            theadId: "Data Transfer Mode",
            children: item?.datatransmode,
            text: item?.datatransmode,
          })
          if(!selectedOption?.isOutletUser){
            tBody?.push(
              // {
              //   id: nanoid(),
              //   theadId: "Revenue Share(%)",
              //   children: item?.rspercent,
              //   text: item?.rspercent,
              // },
              {
                id: nanoid(),
                theadId: "Revenue",
                children: item?.rsvalue,
                text: item?.rsvalue,
              },
            );
          }
          tBody?.push({
            id: nanoid(),
            theadId: "Jan",
            children: item?.jan,
            text: item?.jan,
          },
          {
            id: nanoid(),
            theadId: "Feb",
            children: item?.feb,
            text: item?.feb,
          },
          {
            id: nanoid(),
            theadId: "Mar",
            children: item?.mar,
            text: item?.mar,
          },
          {
            id: nanoid(),
            theadId: "Apr",
            children: item?.apr,
            text: item?.apr,
          },
          {
            id: nanoid(),
            theadId: "May",
            children: item?.may,
            text: item?.may,
          },
          {
            id: nanoid(),
            theadId: "Jun",
            children: item?.jun,
            text: item?.jun,
          },
          {
            id: nanoid(),
            theadId: "Jul",
            children: item?.jul,
            text: item?.jul,
          },
          {
            id: nanoid(),
            theadId: "Aug",
            children: item?.aug,
            text: item?.aug,
          },
          {
            id: nanoid(),
            theadId: "Sep",
            children: item?.sep,
            text: item?.sep,
          },
          {
            id: nanoid(),
            theadId: "Oct",
            children: item?.oct,
            text: item?.oct,
          },
          {
            id: nanoid(),
            theadId: "Nov",
            children: item?.nov,
            text: item?.nov,
          },
          {
            id: nanoid(),
            theadId: "Dec",
            children: item?.dec,
            text: item?.dec,
          }
        );
        tableBody?.push(tBody);
      });
    });

    return { tbody: tableBody, thead: tableHead };
  };

  const handleApply = () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    } else if (brands === "") {
      toast("Select Brand", ToastTypes?.ERROR);
      error = true;
    } else if (
      year === null ||
      (year !== null && year?.getFullYear()?.toString() === "")
    ) {
      toast("Select year", ToastTypes?.ERROR);
      error = true;
    }
    var getData = {
      portfolio: portfolio,
      site: site,
      locality: locality,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: year?.getFullYear(),
      limit: limit?.toString(),
      offset: offset?.toString(),
    };

    if (
      error === false &&
      getData !== undefined &&
      getData?.limit !== "" &&
      getData?.offset !== ""
    ) {
      if (pag === false) {
        setLoader(true);
      }
      api
        .post<APIResponse<{ records: MonthWiseReportType[] }>>(
          "kpi/report/monthwise",
          getData,
          config
        )
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setMonthWiseData(result);
            setLoader(false);
          }
        })
        .catch((error) => {});
    } else {
      setMonthWiseData([]);
      setLoader(false);
    }
  };

  const handlePag = () => {
    setPag(true);
  };

  useEffect(() => {
    if (portfolios !== "" && brands !== "" && fileLoader === false)
      handleApply();
  }, [portfolios]);

  const handleCsvDownload = async () => {
    setFileLoader(true);
    const csvData = await fetchDataForDownload();
    if (
      csvData[0]?.record?.length !== 0 &&
      csvData[0]?.record?.length !== undefined
    ) {
      const d = { ...getDownloadData(csvData) };
      const filteredHead = d?.thead
        ?.map((a) => {
          const foundObject = selectedRows
            ?.map((b) => {
              if (a?.text?.toString() === b?.toString()) {
                return a;
              }
            })
            ?.find((obj) => obj !== undefined);

          if (foundObject !== undefined) {
            return foundObject;
          }
        })
        ?.filter((obj) => obj !== undefined);
      const csvHead = filteredHead;
      const csvBody = d?.tbody;

      const head = [csvHead?.map((h) => h?.text || "") || []];
      const body =
        csvBody?.map((tr, i) => {
          return (
            csvHead?.map((th, j) => {
              const col = tr?.find((r) => r?.theadId === th?.id);
              return col?.text || "";
            }) || []
          );
        }) || [];

      const rows = [...head, ...body];
      const props = {
        rows: rows,
        fileName: "Monthwise Report - Location wise",
      };
      CSVdownload(props);
      setFileLoader(false);
    } else {
      setFileLoader(false);
    }
    setFileLoader(false);
  };

  const handlePdfDownload = async () => {
    setFileLoader(true);
    const pdfData = await fetchDataForDownload();
    if (
      pdfData[0]?.record?.length !== 0 &&
      pdfData[0]?.record?.length !== undefined
    ) {
      const d = { ...getDownloadData(pdfData) };
      const filteredHead = d?.thead
        ?.map((a) => {
          const foundObject = selectedRows
            ?.map((b) => {
              if (a?.text?.toString() === b?.toString()) {
                return a;
              }
            })
            ?.find((obj) => obj !== undefined);

          if (foundObject !== undefined) {
            return foundObject;
          }
        })
        ?.filter((obj) => obj !== undefined);
      const thead = filteredHead;
      const tbody = d?.tbody;

      const head = [thead?.map((h) => h?.text || "") || []];
      const body =
        tbody?.map((tr, i) => {
          return (
            thead?.map((th, j) => {
              const col = tr?.find((r) => r?.theadId === th?.id);
              return col?.text || "";
            }) || []
          );
        }) || [];

      const props = {
        head: head,
        body: body,
        fileName: "Monthwise Report - Location wise",
        title: "Monthwise Report - Location wise",
      };

      handleDownloadPDF(props);
      setFileLoader(false);
    } else {
      setFileLoader(false);
    }
    setFileLoader(false);
  };

  const getTableData = () => {
    var tableHead: Thead[] = tHead;
    var tableBody: Tbody[][] = [];

    const tbody = monthWiseData;

    tbody?.forEach((month, i) => {
      month?.record?.forEach((item) => {
        //     selectedYears?.forEach((sy) => {
        var tBody: Tbody[] = [];
        tBody?.push(
          {
            id: nanoid(),
            theadId: "Trade Category",
            children: item?.tradecategory,
            text: item?.tradecategory,
          },
          {
            id: nanoid(),
            theadId: "Trade Sub Category",
            children: item?.tradesubcategory,
            text: item?.tradesubcategory,
          },
          {
            id: nanoid(),
            theadId: "Brand Name",
            children: item?.brandname,
            text: item?.brandname,
          },
          {
            id: nanoid(),
            theadId: "Level",
            children: item?.level,
            text: item?.level?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Landmark",
            children: item?.landmark,
            text: item?.landmark,
          },
          {
            id: nanoid(),
            theadId: "Data Transfer Mode",
            children: item?.datatransmode,
            text: item?.datatransmode,
          })
          if(!selectedOption?.isOutletUser){
            tBody?.push(
              // {
              //   id: nanoid(),
              //   theadId: "Revenue Share(%)",
              //   children: item?.rspercent,
              //   text: item?.rspercent,
              // },
              {
                id: nanoid(),
                theadId: "Revenue",
                children: item?.rsvalue,
                text: item?.rsvalue,
              },
            );
          }
          tBody?.push({
            id: nanoid(),
            theadId: "Jan",
            children: item?.jan,
            text: item?.jan,
          },
          {
            id: nanoid(),
            theadId: "Feb",
            children: item?.feb,
            text: item?.feb,
          },
          {
            id: nanoid(),
            theadId: "Mar",
            children: item?.mar,
            text: item?.mar,
          },
          {
            id: nanoid(),
            theadId: "Apr",
            children: item?.apr,
            text: item?.apr,
          },
          {
            id: nanoid(),
            theadId: "May",
            children: item?.may,
            text: item?.may,
          },
          {
            id: nanoid(),
            theadId: "Jun",
            children: item?.jun,
            text: item?.jun,
          },
          {
            id: nanoid(),
            theadId: "Jul",
            children: item?.jul,
            text: item?.jul,
          },
          {
            id: nanoid(),
            theadId: "Aug",
            children: item?.aug,
            text: item?.aug,
          },
          {
            id: nanoid(),
            theadId: "Sep",
            children: item?.sep,
            text: item?.sep,
          },
          {
            id: nanoid(),
            theadId: "Oct",
            children: item?.oct,
            text: item?.oct,
          },
          {
            id: nanoid(),
            theadId: "Nov",
            children: item?.nov,
            text: item?.nov,
          },
          {
            id: nanoid(),
            theadId: "Dec",
            children: item?.dec,
            text: item?.dec,
          }
        );
        tableBody?.push(tBody);
      });
    });

    return { tbody: tableBody, thead: tableHead };
  };

  useEffect(() => {
    const header = tHead
      ?.map((a) => a?.text)
      ?.filter((id): id is string => typeof id === "string" && id !== undefined);
    setSelectedRows(header);
  }, []);
  const locality = useMemo<string[]>(() => {
    return locations?.map((p) => {
      return p?.label;
    });
  }, [locations]);
  const portfolio = useMemo<number[]>(() => {
    return portfolios !== "" ? [parseInt(portfolios)] : [];
  }, [portfolios]);

  const site = useMemo<string[]>(() => {
    if (authUserSiteId) {
      return authUserSiteId?.split(",")?.map((s) => {
        return s?.toString();
      });
    } else {
      return [];
    }
  }, [authUserSiteId]);

  const brand = useMemo<number[]>(() => {
    return brands !== "" ? [parseInt(brands)] : [];
  }, [brands]);

  const category = useMemo<number[]>(() => {
    return categories !== "" ? [parseInt(categories)] : [];
  }, [categories]);

  const subCategory = useMemo<number[]>(() => {
    return subCategories !== "" ? [parseInt(subCategories)] : [];
  }, [subCategories]);

  useEffect(()=>{    
    if(selectedOption?.isOutletUser){
      setDisableLocality(true);
      const outletOption:any = outletList[0]
      if(outletOption){
        const localityName:string = outletOption ? outletOption[0]?.area:"";
        const LocalityIndex = localityOption?.findIndex(
          (c) => c?.area !== undefined && c?.area?.toString() === localityName?.toString()
        );
        const locationVal = [{
          value: LocalityIndex,
          label: localityName?.toString(),
          imgUrl: "",
        }]
        setLocations(locationVal)
      }
    }else{
      setDisableLocality(false);
    }
  },[authUser, outletList,selectedOption]);
  useEffect(() => {
    setOffset(0);
  }, [year]);

  useEffect(() => {
    let pid =
      portfolioData[0] && portfolioData[0]?.id
        ? portfolioData[0]?.id?.toString()
        : "";
    setPortfolios(selectedOption?.portfolio ? selectedOption?.portfolio : pid);
  }, [portfolioData, selectedOption]);

  useEffect(() => {
    let sid = siteData[0] && siteData[0]?.id ? siteData[0]?.id?.toString() : "";
    setSites(selectedOption?.site ? selectedOption?.site : sid);
  }, [siteData, selectedOption]);

  useEffect(() => {
    var range = [];
    var num = Math?.ceil(length / limit);
    // let i = 1;
    for (let i = 1; i <= num; i++) {
      range?.push(i);
    }
    setRange(range);
  }, [length, limit]);

  useEffect(() => {
    if (monthWiseData?.length > 0)
      setLength(monthWiseData[0]?.count ? monthWiseData[0]?.count : 0);
  }, [monthWiseData]);

  useEffect(() => {
    setBrands(selectedOption?.brand);
  }, [selectedOption]);

  // useEffect(() => {
  //   if (selectedOption?.locations) setLocations(selectedOption?.locations);
  // }, [selectedOption]);

  useEffect(() => {
    if (selectedOption?.category) setCategories(selectedOption?.category);
  }, [selectedOption]);

  useEffect(() => {
    if (selectedOption?.subCategory)
      setSubCategories(selectedOption?.subCategory);
  }, [selectedOption]);

  useEffect(() => {
    if (sites !== ""&&selectedOption.isOutletUser===true) {
      let siteCurrencyObject = siteOption?.find(
        (s) => s?.id?.toString() === sites?.toString()
      );
      setValueIn(
        siteCurrencyObject?.currencycode +
          " | " +
          siteCurrencyObject?.valuecaption
      );
    } 
    else if(portfolios !== ""&&selectedOption.isOutletUser===false){
      let portfolioCurrencyObject = portfolioOption?.find(
        (s) => s?.id?.toString() === portfolios?.toString()
      );
      setValueIn(
        portfolioCurrencyObject?.reportingcurrency +
          " | " +
          portfolioCurrencyObject?.valuecaption
      );
    }
    else setValueIn("");
  }, [sites, siteOption,selectedOption]);

  useEffect(() => {
    var getData = {
      portfolio: portfolio,
    };

    if (portfolio?.length > 0 && getData !== undefined) {
      api
        .post<
          APIResponse<{ records: CatSubCatCompanyWithBrandRelationDataType[] }>
        >(`filter/catSubcatCompanyRelationWithBrand`, getData, config)
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setCatSubCatCompanyWithBrandRelationData(result);
          }
        })
        .catch((error) => {});
    } else {
      setCatSubCatCompanyWithBrandRelationData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolio]);

  return (
    <UserLayout>
      <div className="card background-transparent p-1">
        <div className="row">
          <div
            className="col-lg-4 wow fadeInLeft ps-0"
            // style="visibility: visible; animation-name: fadeInLeft;"
          >
            <h4 className="b-title">Monthwise Report - Location wise</h4>
          </div>

          <div className="col-lg-8 wow fadeInRight">
            <div className="row">
              <div className="col-sm-6 col-md-4 col-lg-3">
                <FormInput2
                  name="Portfolio"
                  label=""
                  labelClassName="required"
                  value={portfolios}
                  onChange={handlePortfolioChange}
                  placeholder="Select"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select</option>
                  {portfolioData?.map((p, i) => {
                    return (
                      <Option value={p?.id} key={i}>
                        {p?.name}
                      </Option>
                    );
                  })}
                </FormInput2>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                <FormInput2
                  name="Brand"
                  label=""
                  labelClassName="required"
                  value={brands}
                  onChange={handleBrandChange}
                  placeholder="Select Brand"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Brand</option>
                  {BrandFilteredByCompany?.sort(function (a, b) {
                    if (a?.name < b?.name) {
                      return -1;
                    }
                    if (a?.name > b?.name) {
                      return 1;
                    }
                    return 0;
                  })?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
              <MultiSelect
                  options={localityOption?.map((sc) => {
                    return {
                      value: sc?.id ? sc?.id : 0,
                      label: sc?.area?.toString(),
                      imgUrl: "",
                    };
                  })}
                  label=""
                  selectedOptions={locations}
                  setSelectedOptions={setLocations}
                  disabled={disableLocality}
                  placeHolder="All Locality"
                />
              </div>

            </div>

            <div className="row mt-1">
              <div className="col-sm-6 col-md-4 col-lg-3">
                <FormInput2
                  name="Trade Category"
                  label=""
                  labelClassName="required"
                  value={categories}
                  onChange={handleCategoryChange}
                  placeholder="Select Trade Category"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Trade Category</option>
                  {categoryOption?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                <FormInput2
                  name="Trade Sub Category"
                  label=""
                  labelClassName="required"
                  value={subCategories}
                  onChange={handleSubCategoryChange}
                  placeholder="Select Trade Sub Category"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Trade Sub Category</option>
                  {subCategoryFilteredByCategory?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loader ? (
        <Loader />
      ) : (
        <div className="row">
          <div className="col-12">
            <div className="card mt-3">
              <div className="card-body">
                <div className="row mb-1">
                  <div className="col-lg-7 col-sm-12">
                    <div className="float-start">
                      <h5 className="header-title mt-1">
                        <img src={tableIcon} alt="icon"></img>Monthwise Report - Location wise
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg-5 col-sm-12">
                    <div className="float-end hstack gap-2">
                      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                        <div className="DateContainer">
                          <span className="dateInput">
                            <DatePicker
                              id="DatePicker"
                              // type="string"
                              className="text-center fw-bold form-control"
                              selected={year}
                              onChange={(date: any) => setYear(date)}
                              showYearPicker
                              dateFormat="yyyy"
                              yearItemNumber={8}
                              //     required
                            />
                          </span>
                          <span className="icon">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z"
                                fill="#6C757D"
                              ></path>
                            </svg>
                          </span>
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleApply}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <TransactionTable
                  data={[]}
                  {...getTableData()}
                  title=""
                  downloadCSV={true}
                  downloadPDF={true}
                  fileName="Monthwise Report - Location wise"
                  limit={limit}
                  setOffset={setOffset}
                  onClickCSV={handleCsvDownload}
                  onClickPDF={handlePdfDownload}
                  valueInString={valueIn}
                  range={range}
                  onPageNoChange={handleApply}
                  handlePag={handlePag}
                  fLoader={fileLoader}
                  onSelectedRowsChange={handleSelectedRowsChange}
                />
                
              </div>
            </div>
          </div>
        </div>
      )}
    </UserLayout>
  );
};
export default TransactionMonthWiseReportLocwise;
